import type { Fit, Product } from './types';

export const KIDS_SIZES = [
  { size: '16', height: '95–105', age: '3–4', length: 44, width: 35, waist: '20–37' },
  { size: '18', height: '105–115', age: '4–5', length: 47, width: 37, waist: '21–39' },
  { size: '20', height: '115–125', age: '5–6', length: 50, width: 39, waist: '22–41' },
  { size: '22', height: '125–135', age: '6–7', length: 53, width: 41, waist: '23–42' },
  { size: '24', height: '135–145', age: '8–9', length: 56, width: 43, waist: '24–44' },
  { size: '26', height: '145–155', age: '10–11', length: 59, width: 45, waist: '25–47' },
  { size: '28', height: '155–165', age: '12–13', length: 62, width: 47, waist: '26–50' }
] as const;

export const FIT_LABELS: Record<Fit, string> = {
  hombre: 'Hombre', mujer: 'Mujer', nino: 'Niño', sin_especificar: ''
};

// 4XL and 5XL remain valid in historical orders and product data, but are no
// longer offered in either storefront. Keep this rule at the presentation
// boundary so existing records are never rewritten or made unreadable.
export function customerVisibleAdultSizes(sizes: string[]): string[] {
  return sizes.filter(size => !/^[45]\s*XL$/i.test(size.trim()));
}

export function availableSizesFor(product: Pick<Product, 'availableSizes' | 'kidsEnabled'>, fit: Fit): string[] {
  return fit === 'nino'
    ? (product.kidsEnabled ? KIDS_SIZES.map(row => row.size) : [])
    : customerVisibleAdultSizes(product.availableSizes);
}

export function resolveSizeForFit(product: Pick<Product, 'availableSizes' | 'kidsEnabled'>, fit: Fit, preferred?: string | null): string {
  const sizes = availableSizesFor(product, fit);
  if (preferred && sizes.includes(preferred)) return preferred;
  if (!sizes.length) throw new Error('Esta camiseta no tiene tallas para la categoría elegida.');
  return sizes[0];
}
